import Logo from "./logo";

// The Alien skin's saucer runs a long, mostly-idle cycle: it drops in, beams
// the wordmark up, holds an empty sky, then puts it back. All CSS — a popup
// that is usually open for seconds should not pay for an animation loop.
function AlienAbduction({ isPro, trialMode }) {
  return (
    <div className="skin-logo__alien">
      <div className="skin-logo__ufo" aria-hidden="true">
        <span className="skin-logo__ufo-dome" />
        <span className="skin-logo__ufo-hull" />
      </div>
      <div className="skin-logo__beam" aria-hidden="true" />
      <div className="skin-logo__abductee">
        <Logo isPro={isPro} trialMode={trialMode} />
      </div>
    </div>
  );
}

export default function SkinLogo({ skin, isPro, trialMode, announcement }) {
  const mark = renderMark({ skin, isPro, trialMode });

  if (!announcement) return mark;

  // Brief mood name in the header after apply. The mark stays mounted
  // underneath and the two cross-fade on one timeline: swapping the elements
  // outright made the name appear from nowhere and the mark snap back at the
  // end.
  return (
    <div className="skin-logo__swap" key={announcement}>
      <div className="skin-logo__swap-mark">{mark}</div>
      <div className="skin-logo__swap-name">
        <span>{announcement}</span>
      </div>
    </div>
  );
}

function renderMark({ skin, isPro, trialMode }) {
  if (skin === "alien") {
    return <AlienAbduction isPro={isPro} trialMode={trialMode} />;
  }

  // Dracula: drops gather under the wordmark and run off it. Three of them on
  // offset cycles, so it drips irregularly instead of in time with itself.
  if (skin === "dracula") {
    return (
      <div className="skin-logo__dracula">
        <Logo isPro={isPro} trialMode={trialMode} />
        <span className="skin-logo__drip skin-logo__drip--1" aria-hidden="true" />
        <span className="skin-logo__drip skin-logo__drip--2" aria-hidden="true" />
        <span className="skin-logo__drip skin-logo__drip--3" aria-hidden="true" />
      </div>
    );
  }

  // Maximalist: the wordmark printed in poster red with a misregistered blue
  // plate behind it and a lime marker swipe underneath.
  if (skin === "maximalist") {
    return (
      <div className="skin-logo__maximalist">
        <span className="skin-logo__maximalist-swipe" aria-hidden="true" />
        <Logo isPro={isPro} trialMode={trialMode} />
      </div>
    );
  }

  return <Logo isPro={isPro} trialMode={trialMode} />;
}
